import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import '../stylesheets/Heading.css';

export function Heading() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogOutBtn = () => {
    const confirm = window.confirm('Are you sure you want to log out?');

    if (confirm) {
      logout();
      navigate('/login');
      window.location.reload();
    }
  }

  return (
    <div className='Heading'>
      <Link to='/admin' className='title'>Admin page</Link>
      <Button type='default' onClick={handleLogOutBtn}>Sign out</Button>
    </div>
  )
}
